import React from "react";
import get from "lodash.get";
import { connect } from "react-redux";

import MapCarMarker from "components/MapCarMarker";
import NonMovingCarsActioner from "services/nonMovingCars/actioner";
import MapUtils from "services/map/utils";

function NonMovingCarsLayers({
  customMarkers,
  hoverIndex,
  nonMovingCars,
  selectedIndex,
  setSelectedIndex,
  zoom,
}) {
  if (!nonMovingCars.initialized) {
    return null;
  }

  return nonMovingCars.items.map((nonMovingCar, index) => {
    return (
      <MapCarMarker
        hover={hoverIndex === index}
        selected={selectedIndex === index}
        center={MapUtils.getNormalizedCoordinates(nonMovingCar.position)}
        zoom={zoom}
        options={{
          ...nonMovingCar,
          timestamp: Math.round(new Date().getTime() / 1000),
          ...(customMarkers || {}),
        }}
        key={index}
        onPopupClose={() => setSelectedIndex(null)}
        onPopupOpen={() => setSelectedIndex(index)}
      />
    );
  });
}

const mapStateToProps = (state) => ({
  customMarkers: get(state.Map, "config.custom_markers", {}),
  zoom: MapUtils.getZoom(state.Map),
  nonMovingCars: state.NonMovingCars.list,
  selectedIndex: state.NonMovingCars.list.selectedIndex,
  hoverIndex: state.NonMovingCars.list.hoverIndex,
});

const mapDispatchToProps = (dispatch) => ({
  setSelectedIndex: (value) =>
    dispatch(NonMovingCarsActioner.setSelectedIndex(value)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NonMovingCarsLayers);
